import { useEffect, useState } from 'react';

import { useAuthenticationDataContext } from '../../Helpers/AuthenticationDataProvider';
import { useAuthorizationDataContext } from '../../Helpers/AuthorizationDataProvider';

import { usePopupContext } from '../../Helpers/PopupProvider';
import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { CurrentUserResponse } from '../../pages/EditCurrentProfile/EditCurrentProfile.model';

const useHeader = () => {
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const [showContactDropdown, setShowContactDropdown] = useState(false);
	const [showInviteDropdown, setShowInviteDropdown] = useState(false);
	const { isAuthenticated, imageId, userId, setImageId } = useAuthenticationDataContext();
	const { isAuthorized, role } = useAuthorizationDataContext();
	const { toggleSideNav } = usePopupContext();
	const { get } = useFetchWrapper();
	const [showMyProfileDropdown, setShowMyProfileDropdown] = useState<boolean>(false);

	const { onPopupClose, onPopupOpen } = usePopupContext();



	const toggleContactDropdown = () => {
		if (showContactDropdown) {
			onPopupClose()
		}
		setShowContactDropdown((currentValue: boolean) => !currentValue);
		setShowMyProfileDropdown(false)
	}

	const toggleInviteDropdown = () => {
		if (showInviteDropdown) {
			onPopupClose()
		}
		setShowInviteDropdown((currentValue: boolean) => !currentValue);
		setShowMyProfileDropdown(false);
		setShowContactDropdown(false);
	}

	const toggleMyProfileDropdown =() => {
		if(showMyProfileDropdown) {
			onPopupClose()
		} else {
			onPopupOpen()
		}
		setShowMyProfileDropdown((currentValue: boolean) => !currentValue);
		setShowContactDropdown(false);
		setShowInviteDropdown(false);
	}

	useEffect(() => {
		setIsLoggedIn(isAuthenticated());
	}, [isAuthenticated])

	useEffect(() => {
		if (userId) {
			getCurrentUser(userId);
		}
	}, [userId])

	const getCurrentUser = async (userId: string) => {
		const response: HttpResponse<CurrentUserResponse> = await get(`/user/profile/${userId}`);
		if (response.parsedBody) {
			const user = response.parsedBody;
			setImageId(user.imageId);
		}
	}

	return {
		imageId,
		isAuthorized,
		state: {
			isLoggedIn,
			role,
			showContactDropdown,
			showInviteDropdown,
			showMyProfileDropdown,
		},
		toggleContactDropdown,
		toggleInviteDropdown,
		toggleMyProfileDropdown,
		toggleSideNav,
	};
}

export default useHeader;

